import { FormControl, FormGroup } from '@angular/forms';
import { Injectable, Injector } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class Messages {

    constructor() { }

    DATEWITHTIMEFORMATFORCONVERSION = "YYYY-MM-DD HH:mm:ss";

    appStaticMessages = {
        CHECKCONNECTION: 'Please check your connection and try after sometimes'
    }

    screenName = {
        REPORTINSTANCEDETAILSVIEW : 'reportinstancedetails_view'
    }

    whereMessages = {
        'fieldsWhere': [
            { type: 'required', message: 'Fields is required.' }
        ],
        'conditionalOperatorWhere': [
            { type: 'required', message: 'Conditional Operator is required.' }
        ],
        'enterValueWhere': [
            { type: 'required', message: 'Enter Value is required.' },
            { type: 'whitespace', message: 'Enter Value should not contain any white spaces.' }
        ],
        'logicalOperatorWhere': [
            { type: 'required', message: 'Logical Operator is required.' }
        ]
    }

    groupByMessages = {
        'fieldsGroupBy': [
            { type: 'required', message: 'Fields is required.' }
        ]
    }

    orderByMessages = {
        'fieldsOrderBy': [
            { type: 'required', message: 'Fields is required.' }
        ],
        'arrangeOrderBy': [
            { type: 'required', message: 'Arrange is required.' }
        ]
    }

    connectMessages = {
        'databaseName': [
            { type: 'required', message: 'Database Name is required.' },
            { type: 'whitespace', message: 'Database Name should not contain any white spaces.' }
        ],
        'server': [
            { type: 'required', message: 'Server is required.' },
            { type: 'whitespace', message: 'Server should not contain any white spaces.' }
        ],
        'portNumber': [
            { type: 'required', message: 'Port Number is required.' },
            { type: 'whitespace', message: 'Port Number should not contain any white spaces.' }
        ],
        'username': [
            { type: 'required', message: 'Username is required.' },
            { type: 'whitespace', message: 'Username should not contain any white spaces.' }
        ],
        'password': [
            { type: 'required', message: 'Password is required.' },
            { type: 'whitespace', message: 'password should not contain any white spaces.' }
        ]
    }

    reportConfigurationLinkMessages = {
        'tableName': [
            { type: 'required', message: 'Table Name is required.' }
        ]
    }

}

